<template>
  <div style="width: 100%; height: 100%">
    <div class="content" :class="classObj">
      <div class="side-container">
        <el-scrollbar wrap-style="overflow-x:hidden;">
          <el-menu
            router
            class="el-menu-vertical-demo"
            :default-active="activeMenu"
            :collapse="isCollapse"
            background-color="#28333E"
            text-color="rgb(191, 203, 217)"
            active-text-color="#1890ff"
          >
            <el-menu-item index="1" disabled style="opacity: 1">
              <i class="el-icon-menu"></i>
              <span slot="title" style="color: rgb(191, 203, 217)">{{
                this.$application_name
              }}</span>
            </el-menu-item>
            <el-menu-item
              v-for="(item, i) in menuData"
              :key="i"
              :index="item.url + ''"
            >
              <i :class="[item.icon]"></i>
              <span>{{ item.name }}</span>
            </el-menu-item>
          </el-menu>
          <div class="ban" v-if="!isCollapse">
            技术支持&nbsp;&copy;&nbsp;1.0.0&nbsp;<span style="color: #409eff"
              >武汉科情</span
            >
          </div>
        </el-scrollbar>
      </div>
      <div class="main-content">
        <div class="main-content-header">
          <div class="main-content-nav">
            <div class="hamburger">
              <i
                class="el-icon-s-unfold"
                v-if="isCollapse"
                v-on:click="chageCollpse"
              ></i>
              <i class="el-icon-s-fold" v-else v-on:click="chageCollpse"></i>
            </div>
            <el-dropdown style="display: flex; align-items: center">
              <span class="el-dropdown-link">
                <i class="el-icon-user-solid el-icon--left"></i>admin<i
                  class="el-icon-arrow-down el-icon--right"
                ></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>admin</el-dropdown-item>
                <!-- <el-dropdown-item v-on:click.native="changePassword">修改密码</el-dropdown-item>
                   <el-dropdown-item v-on:click.native="flushCache" divided>清空缓存</el-dropdown-item>-->
                <el-dropdown-item divided @click.native="backLogin"
                  >退出登录</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="tags-view-container"></div>
        </div>
        <div class="main-content-con">
          <el-scrollbar wrap-style="overflow-x:auto;margin-bottom: -17px;">
            <el-card class="box-card">
              <slot name="mian_con"></slot>
            </el-card>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utility from '@/components/mixin.js'
import axios from 'axios'
export default {
  mixins: [Utility],
  components: {},
  data() {
    return {
      navbar: {},
      anthenticated: false,
      token: '',
      menuData: [], //导航栏路由,
      isCollapse: false, //控制右侧导航栏收缩
      chpvisio: false,
      apiList: [],
      taskList: [],
      application_name: ''
    }
  },
  created() {
    this.token = localStorage.getItem('token')
    axios
      .all([
        axios
          .get('/mananger/port/list?token=' + this.token)
          .then((res) => res.data),
        axios
          .get('/mananger/task/list?token=' + this.token)
          .then((res) => res.data)
      ])
      .then(
        axios.spread((val1, val2) => {
          if (val1.code === 1 && val2.code === 1) {
            this.apiList = val1.data
            this.taskList = val2.data
            if (this.apiList.length === 0 && this.taskList.length === 0) {
              this.menuData = []
            }
            if (this.apiList.length != 0 && this.taskList.length === 0) {
              // const DynamicRoutes = []
              this.menuData = [
                {
                  icon: 'el-icon-postcard',
                  name: 'API看板',
                  ename: 'apiList',
                  url: '/api/list'
                }
              ]
              // DynamicRoutes.push({
              //   path: '/api/list',
              //   name: 'apiList',
              //   component: () =>
              //     import(
              //       /* webpackChunkName: "about" */ '@/components/ApiList'
              //     ),
              //   meta: {
              //     isAnthenticated: true
              //   }
              // })
              // this.$router.addRoutes(DynamicRoutes)
            }
            if (this.taskList.length != 0 && this.apiList.length === 0) {
              this.menuData = [
                {
                  icon: 'el-icon-postcard',
                  name: '任务看板',
                  ename: 'taskList',
                  url: '/task/list'
                }
              ]
              // const DynamicRoutes = []
              // DynamicRoutes.push({
              //   path: '/task/list',
              //   name: 'taskList',
              //   component: () =>
              //     import(
              //       /* webpackChunkName: "about" */ '@/components/TaskList'
              //     ),
              //   meta: {
              //     isAnthenticated: true
              //   }
              // })
              // this.$router.addRoutes(DynamicRoutes)
            }
            if (this.apiList.length != 0 && this.taskList.length != 0) {
              this.menuData = [
                {
                  icon: 'el-icon-postcard',
                  name: '任务看板',
                  ename: 'taskList',
                  url: '/task/list'
                },
                {
                  icon: 'el-icon-postcard',
                  name: 'API看板',
                  ename: 'apiList',
                  url: '/api/list'
                }
              ]
              // const DynamicRoutes = []
              // DynamicRoutes.push(
              //   {
              //     path: '/api/list',
              //     name: 'apiList',
              //     component: () =>
              //       import(
              //         /* webpackChunkName: "about" */ '@/components/ApiList'
              //       ),
              //     meta: {
              //       isAnthenticated: true
              //     }
              //   },
              //   {
              //     path: '/task/list',
              //     name: 'taskList',
              //     component: () =>
              //       import(
              //         /* webpackChunkName: "about" */ '@/components/TaskList'
              //       ),
              //     meta: {
              //       isAnthenticated: true
              //     }
              //   }
              // )
              // this.$router.addRoutes(DynamicRoutes)
            }
          } else {
            this.err_process(val1.code, val1.message)
          }
        })
      )
      .catch((err) => {
        console.error(err)
        this.err_process('AAAA', '获取数据异常:[AAAA]' + err)
      })
    axios
      .get('../static/applicationname.json')
      .then((res) => {
        this.application_name = res.data.application_name
        // console.log('1'+application_name)
      })
      .catch((err) => {
        console.log('application_name ' + err)
      })
    //this.initMenu()
  },
  mounted() {
    let flag = localStorage.getItem('Flag')

    if (flag === 'true') {
      this.token = localStorage.getItem('token')
      this.anthenticated = true
    } else {
      this.$router.push('/login')
    }
    // if (flag === 'true') {
    //   axios.post('/token/check',{
    //     entId:this.usrinfo.entid,
    //     username:this.usrinfo.ename,
    //     password:this.usrinfo.password,
    //     token:this.token
    //   }).then(respose=>{
    //     let res = response.data
    //     console.log(res);
    //     if(res.code===200){
    //       this.anthenticated=true
    //     }else{
    //       this.err_process(res.code, res.message)
    //     }
    //   }).catch(err => {
    //    console.error(err)
    //    this.anthenticated = false
    //  })
    // }
  },
  computed: {
    classObj() {
      return {
        hideMenu: this.isCollapse,
        openMenu: !this.isCollapse
      }
    },
    activeMenu() {
      return this.$route.fullPath
    }
  },
  methods: {
    //导航栏路由初始化
    // initMenu(){
    //     console.log('ss'+this.application);
    //     this.menuData=[
    //         {
    //             icon: 'el-icon-postcard',
    //             name: this.application+'任务看板',
    //             ename:"taskList",
    //             url:'/task/list',
    //         },
    //     ]
    // },
    backLogin() {
      localStorage.removeItem('token')
      this.$router.push('/login')
    },
    //清空缓存
    flushCache() {
      axios
        .get('/utility/flushcache?entid=' + this.usrinfo.entid)
        .then((response) => {
          let res = response.data
          if (res.retcode === '0000') {
            this.msgBox('清空完成！！')
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    //开关收索栏
    chageCollpse() {
      this.isCollapse = !this.isCollapse
    },
    changePassword() {
      this.$nextTick(function () {
        this.$refs.changepassword.chpvisible = true
      })
    }
  }
}
</script>
<style scoped>
.content {
  position: relative;
  height: 100%;
  width: 100%;
}
.hideMenu .main-content {
  margin-left: 54px !important;
}
.main-content {
  position: relative;
  min-height: 100%;
  margin-left: 210px;
}
.main-content-nav {
  display: flex;
  justify-content: space-between;
}
.main-content-nav {
  box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
  height: 50px;
}
.layui-content {
  background-color: #fff;
}
.layui-content .layui-nav-item a {
  color: rgba(107, 107, 107, 0.7);
}
.el-submenu .el-menu-item {
  background-color: #1f2d3d !important;
}
.el-menu-item .is-active {
  background-color: #1f2d3d !important;
}
.hideMenu .main-content-header {
  margin-left: 54px;
  width: calc(100% - 54px) !important;
}
.main-content-header {
  position: fixed;
  margin-left: 210px;
  height: 84px;
  width: calc(100% - 210px) !important;
  top: 0;
  left: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1001;
  background-color: white;
  border-bottom: 1px solid #d8dce5 !important;
  box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
}
.main-content-con {
  margin-top: 84px;
  position: relative;
  min-width: 100%;
  height: 100%;
}
.side-container {
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  width: 210px;
  background-color: #28333e;
  z-index: 1001;
  transition: width 0.28s;
}
.hideMenu .side-container {
  width: 54px !important;
}
.side-container .el-scrollbar {
  height: 100%;
}
.main-content-con .el-scrollbar {
  height: calc(100% - 85px);
}
.side-container .el-menu {
  border: none;
  height: 100%;
  width: 100% !important;
}
.content_div {
  padding: 0 15px;
}
.hamburger {
  display: flex;
  align-items: center;
  font-size: 22px;
  color: #1f2d3d;
}
.tags-view-container {
  display: flex;
  height: 34px;
  width: 100%;
}
.btn_left {
  font-size: 20px;
  border-right: 1px solid #d8dce5 !important;
  box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btn_right {
  height: 34px;
  font-size: 20px;
  border-left: 1px solid #d8dce5 !important;
  box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
  display: flex;
  justify-content: center;
  background-color: white;
  align-items: center;
  position: absolute;
  right: 0px;
  cursor: pointer;
}
.ban {
  color: rgb(191, 203, 217);
  font-size: 12px;
  position: fixed;
  bottom: 0px;
  left: 30px;
}
</style>